export const getInProgressFields = (prospectRows: any[]) => {
  let fieldIds = [];
  const prospectIds = [];

  if (!prospectRows || prospectRows.length === 0) {
    return null;
  }

  prospectRows.forEach((prospect) => {
    if (prospect?.inProgressTableCells?.length > 0) {
      fieldIds = [
        ...fieldIds,
        ...prospect.inProgressTableCells.map((i: string) => i),
      ];
      prospectIds.push(prospect.id?.toString() || '');
    }
  });
  const fieldIdsSet = new Set(fieldIds);
  const prospectIdsSet = new Set(prospectIds);

  return {
    fieldIds: Array.from(fieldIdsSet).filter(Boolean),
    prospectIds: Array.from(prospectIdsSet).filter(Boolean),
  };
};
